// extracted by mini-css-extract-plugin
export var actions = "_qr-4";
export var item = "_qr-1";
export var price = "_qr-3";
export var quantity = "_qr-2";
export var table = "_qr-0";